'use strict';

require('./RoomService');
var log = require('../../log/Log').channel('CameraController');
var sutl = require('../../sutl/Sutl');
var defaults = require('../../defaults/Defaults');
require('./PresetButtonDirective');
require('./RoomService');
require('./SelectMenuPositionService');

angular
    .module('inara')
    .directive('selfViewPosition', function () {
        // Directive defining self view position selection
        return {
            restrict: 'E',
            templateUrl: 'selfViewPosition.html',
            scope: {
                vm: '<',
                position: '<',
            },
        };
    })

    .controller('CameraController', CameraController);

CameraController.$inject = [
    '$scope',
    '$timeout',
    'ionicMaterialInk',
    'KayleeService',
    'RoomService',
    '$ionicPopover',
    'SelectMenuPositionService',
    '$ionicPosition',
    '$ionicScrollDelegate',
    '$q',
    'gettextCatalog',
    'IosTouchEventService',
];

function CameraController(
    $scope,
    $timeout,
    ionicMaterialInk,
    KayleeService,
    RoomService,
    $ionicPopover,
    SelectMenuPositionService,
    $ionicPosition,
    $ionicScrollDelegate,
    $q,
    gettextCatalog,
    IosTouchEventService
) {
    var vm = this;
    var cameraPresetIcons = {
        camera_wide: 'ion-aveo-room',
        camera_medium: 'ion-aveo-people',
        camera_closeup: 'ion-aveo-directory',
        camera_lectern: 'ion-aveo-lectern',
    };
    var cameraPresetRunningDuration = 1500; // time in ms for running indicator
    var cameraPresetUiStates = {};
    var camerasMenu = null;
    var cameraSwitcherId = null;
    var cameraUiStates = {};
    var cameraSwitcherStates = {};
    var selectedCameraId = null;
    var previousCameras = null;
    var previousCameraPresets = null;
    var room = null;
    var selfViewMenu = null;
    var userSelectedCamera = false;
    var wrappedCameraPositionHandlers = IosTouchEventService.wrapHandlers(
        incrementNearCameraPositionTouch,
        incrementNearCameraPositionRelease
    );

    log.info('initializing');

    ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });

    vm.cameraPresetsCount = cameraPresetsCount;
    /// Label for toggle to enable/disable camera function to automatically track people
    vm.getNearCameraTrackingButtonLabel = function () {
        return gettextCatalog.getString('Track People');
    };
    /// Placeholder for camara selection dropdown with nothing selected
    vm.getNoCameraName = function () {
        return gettextCatalog.getString('None');
    };
    vm.getPresetIcon = getPresetIcon;
    vm.getSelectedCamera = getSelectedCamera;
    /// Label for toggle to enable/disable self view auto function
    vm.getSelfViewAutoEnabledButtonLabel = function () {
        return gettextCatalog.getString('Auto Self View');
    };
    /// Label for toggle to enable/disable self view function
    vm.getSelfViewEnabledButtonLabel = function () {
        return gettextCatalog.getString('Self View');
    };
    vm.hasSelfView = hasSelfView;
    vm.hasSelfViewAuto = hasSelfViewAuto;
    vm.hasSelfViewPosition = hasSelfViewPosition;
    vm.hasSelfViewPositions = hasSelfViewPositions;
    vm.hasSelfViewUi = hasSelfViewUi;
    vm.incrementNearCameraPositionTouch = wrappedCameraPositionHandlers.onTouch;
    vm.incrementNearCameraPositionRelease = wrappedCameraPositionHandlers.onRelease;
    vm.isCameraSwitcherAvailable = isCameraSwitcherAvailable;
    vm.isCameraSwitcherBusy = isCameraSwitcherBusy;
    vm.isPresetRunning = isPresetRunning;
    vm.isPresetSelected = isPresetSelected;
    vm.isSelectedCameraBusy = isSelectedCameraBusy;
    vm.isSelfViewAvailable = isSelfViewAvailable;
    vm.isSelfViewPositionSelected = isSelfViewPositionSelected;
    vm.onShowSelfViewMenu = onShowSelfViewMenu;
    vm.onSelectSelfViewPosition = onSelectSelfViewPosition;
    vm.nearCameraTracking = nearCameraTracking;
    vm.onShowCameraMenu = onShowCameraMenu;
    vm.onSelectCamera = onSelectCamera;
    vm.onSelectCameraPreset = onSelectCameraPreset;
    vm.selfView = selfView;
    vm.selfViewAuto = selfViewAuto;

    RoomService.onOnlineChanged(onRoomServiceOnlineChanged);
    $scope.$on('$stateChangeSuccess', onStateChange);

    $scope.$on('$ionicView.enter', function () {
        if (vm.cameraPresetsCount() > 0) {
            $ionicScrollDelegate.$getByHandle('camera-presets-scroll').scrollTop(false);
        }
    });

    $scope.$on('$destroy', function () {
        RoomService.offOnlineChanged(onRoomServiceOnlineChanged);

        if (room !== null) {
            room.$offChange(onRoomChanged);
            room = null;
        }
    });

    $scope.$on('popover.hidden', function ($event, popover) {
        if (popover === camerasMenu) {
            delete $scope.camera;
            $ionicScrollDelegate.$getByHandle('cameras-scroll').scrollTop(false);
        }
    });

    function cameraPresetsCount() {
        var cameraPresets = sutl.getNode(room, [
            'caps',
            'cameraSwitchers',
            cameraSwitcherId,
            'cameraPresets',
        ]);
        return room !== null && cameraSwitcherId !== null && cameraPresets !== null
            ? Object.keys(cameraPresets).length
            : 0;
    }

    function getPresetIcon(preset) {
        if (
            room === null ||
            !RoomService.online() ||
            !preset ||
            !angular.isDefined(preset.icon) ||
            !cameraPresetIcons.hasOwnProperty(preset.icon)
        ) {
            return '';
        }
        return cameraPresetIcons[preset.icon];
    }

    function getSelectedCamera() {
        return angular.isDefined(selectedCameraId) && selectedCameraId !== null
            ? vm.cameras[selectedCameraId]
            : null;
    }

    function hasCameras() {
        if (
            room === null ||
            !angular.isDefined(room.caps.cameraSwitchers) ||
            Object.keys(room.caps.cameraSwitchers).length === 0
        ) {
            return false;
        }
        return true;
    }

    function hasSelfView() {
        return sutl.getNode(
            room,
            ['caps', 'cameraSwitchers', cameraSwitcherId, 'hasSelfView'],
            false
        );
    }

    function hasSelfViewAuto() {
        return sutl.getNode(
            room,
            ['caps', 'cameraSwitchers', cameraSwitcherId, 'hasSelfViewAuto'],
            false
        );
    }

    function hasSelfViewPosition(position) {
        var positions = sutl.getNode(room, [
            'caps',
            'cameraSwitchers',
            cameraSwitcherId,
            'selfViewPositions',
        ]);
        return positions !== null && positions.includes(position);
    }

    function hasSelfViewPositions() {
        return (
            sutl.getNode(room, [
                'caps',
                'cameraSwitchers',
                cameraSwitcherId,
                'selfViewPositions',
            ]) !== null
        );
    }

    function hasSelfViewUi() {
        return sutl.getNode(
            room,
            ['caps', 'cameraSwitchers', cameraSwitcherId, 'hasSelfViewUi'],
            false
        );
    }

    function incrementNearCameraPositionRelease($event, axis) {
        if (!RoomService.online()) return;
        if (selectedCameraId === null) return;

        room.$requestCameraMove(selectedCameraId, {
            action: 'stop',
            direction: {
                '+x': 'right',
                '-x': 'left',
                '+y': 'up',
                '-y': 'down',
                '+z': 'in',
                '-z': 'out',
            }[axis],
        });
    }

    function incrementNearCameraPositionTouch($event, axis, increment, repeatMs) {
        // repeatMs is undefined or an integer indicating the number of
        // milliseconds before the handler will fire again due to touch-repeat
        if (!RoomService.online()) return;
        if (selectedCameraId === null) return;

        if (axis !== 'x' && axis !== 'y' && axis !== 'z') {
            log.error(
                'incrementNearCameraPositionTouch requires ' +
                    "'x', 'y', or 'z' as the first parameter!"
            );
            return;
        }

        if (!angular.isDefined(increment)) {
            increment = 1;
        }

        var info = {
            x: axis === 'x' ? increment : 0,
            y: axis === 'y' ? increment : 0,
            z: axis === 'z' ? increment : 0,
        };

        if (typeof repeatMs === 'undefined') {
            info.action = 'start';

            if (axis === 'x') {
                info.direction = increment > 0 ? 'right' : 'left';
            } else if (axis === 'y') {
                info.direction = increment > 0 ? 'up' : 'down';
            } else {
                // axis === 'z'
                info.direction = increment > 0 ? 'in' : 'out';
            }
        }

        room.$requestCameraMove(selectedCameraId, info, repeatMs);
    }

    function initializeCameraPresetUiStates() {
        if (Object.keys(vm.cameraPresets).length === 0) {
            cameraPresetUiStates = {};
            return;
        }
        for (var key in vm.cameraPresets) {
            if (cameraPresetUiStates.hasOwnProperty(key)) {
                // we already have a UI state, nothing to update
            } else {
                cameraPresetUiStates[key] = {};
                cameraPresetUiStates[key].running = false;
            }
        }
        for (key in cameraPresetUiStates) {
            if (vm.cameraPresets.hasOwnProperty(key)) {
                // nothing to do since the camera preset exists
            } else {
                // remove old UI state for a non-existent camera preset
                delete cameraPresetUiStates[key];
            }
        }
    }

    function initializeCameraUiStates() {
        if (Object.keys(vm.cameras).length === 0) {
            cameraUiStates = {};
            return;
        }
        for (var key in vm.cameras) {
            if (cameraUiStates.hasOwnProperty(key)) {
                // we already have a UI state, nothing to update
            } else {
                // add a new UI state for this camera
                cameraUiStates[key] = {};
                cameraUiStates[key].selected = false;
                cameraUiStates[key].tracking = false;
            }
        }
        for (key in cameraUiStates) {
            if (vm.cameras.hasOwnProperty(key)) {
                /// nothing to do since the camera exists
            } else {
                // remove old UI state for a non-existent camera
                delete cameraUiStates[key];
            }
        }
    }

    function isCameraSwitcherAvailable() {
        return sutl.getNode(room, ['caps', 'cameraSwitchers', cameraSwitcherId]) !== null;
    }

    function isCameraSwitcherBusy() {
        return sutl.getNode(room, ['states', 'cameraSwitchers', cameraSwitcherId, 'busy'], false);
    }

    function isPresetRunning(preset) {
        return cameraPresetUiStates[preset.$key].running;
    }

    function isPresetSelected(preset) {
        return cameraPresetUiStates[preset.$key].selected;
    }

    function isSelectedCameraBusy() {
        return (
            angular.isDefined(selectedCameraId) &&
            selectedCameraId !== null &&
            isCameraSwitcherBusy()
        );
    }

    function isSelfViewAvailable() {
        return sutl.getNode(
            room,
            ['states', 'cameraSwitchers', cameraSwitcherId, 'selfViewAvailable'],
            true
        );
    }

    function isSelfViewPositionSelected(position) {
        return (
            sutl.getNode(room, [
                'states',
                'cameraSwitchers',
                cameraSwitcherId,
                'selfViewPosition',
            ]) === position
        );
    }

    function nearCameraTracking(enable) {
        if (selectedCameraId === null) return;
        if (arguments.length > 0) {
            cameraUiStates[selectedCameraId].tracking = enable;
            room.$requestCameraTracking(selectedCameraId, enable);
        } else {
            return cameraUiStates[selectedCameraId].tracking;
        }
    }

    function onRoomChanged() {
        if (room === null || !RoomService.online()) return;
        var key;
        var cameraSwitcherIds = Object.keys(sutl.getNode(room, 'caps.cameraSwitchers', {})).sort();
        var tempCameraSwitcherId = null;
        for (var i = 0; i < cameraSwitcherIds.length; i++) {
            if (!sutl.getNode(room.caps.cameraSwitchers[cameraSwitcherIds[i]], 'isHidden', false)) {
                tempCameraSwitcherId = cameraSwitcherIds[i];
                break;
            }
        }
        cameraSwitcherId = tempCameraSwitcherId;
        var cameras =
            cameraSwitcherIds.length > 0
                ? sutl.getNode(room, ['caps', 'cameraSwitchers', cameraSwitcherId, 'cameras'])
                : null;

        if (previousCameras === null || !sutl.objEquals(previousCameras, cameras)) {
            previousCameras = sutl.deepCopy(cameras);
            vm.cameras = angular.extend({}, cameras ? cameras : {});
            initializeCameraUiStates();
        }
        var cameraPresets =
            cameraSwitcherIds.length > 0
                ? sutl.getNode(room, ['caps', 'cameraSwitchers', cameraSwitcherId, 'cameraPresets'])
                : null;

        if (previousCameraPresets === null || !sutl.objEquals(previousCameraPresets, cameraPresets)) {
            previousCameraPresets = sutl.deepCopy(cameraPresets);
            vm.cameraPresets = angular.extend({}, cameraPresets ? cameraPresets : {});
            initializeCameraPresetUiStates();
        }

        if (hasCameras()) {
            if (camerasMenu === null) {
                $ionicPopover
                    .fromTemplateUrl('camerasMenu.html', {
                        scope: $scope,
                        // HACK/undocumented: positionView overrides an internal
                        // positioning function, due to being combined via an internal
                        // .extend()
                        positionView: SelectMenuPositionService.createPositionViewHandler(
                            '#dummy-source-item',
                            vm.cameras ? Object.keys(vm.cameras).length : 0
                        ),
                    })
                    .then(function (popover) {
                        camerasMenu = popover;
                    });
            }
        }

        if (hasSelfViewUi()) {
            if (selfViewMenu === null) {
                $ionicPopover
                    .fromTemplateUrl('selfViewPositionMenu.html', {
                        scope: $scope,
                        // HACK/undocumented: positionView overrides an internal
                        // positioning function, due to being combined via an internal
                        // .extend()
                        positionView: SelectMenuPositionService.createPositionViewHandler(),
                    })
                    .then(function (popover) {
                        selfViewMenu = popover;
                    });
            }
        }

        if (cameraSwitcherIds.length > 0) {
            var cameraSwitcher = sutl.getNode(room, [
                'states',
                'cameraSwitchers',
                cameraSwitcherId,
            ]);
            if (cameraSwitcher !== null) {
                cameraSwitcherStates[cameraSwitcherId] = {};
                cameraSwitcherStates[cameraSwitcherId].selfViewAuto = sutl.getNode(
                    cameraSwitcher,
                    'selfViewAuto',
                    false
                );
                cameraSwitcherStates[cameraSwitcherId].selfView = sutl.getNode(
                    cameraSwitcher,
                    'selfView',
                    false
                );
                for (key in cameraSwitcher.cameras) {
                    if (cameraSwitcher.cameras.hasOwnProperty(key)) {
                        // room.states...cameras will briefly indicate two cameras
                        // as selected as the camera selection transitions, so smooth
                        // out our UI camera selected states.
                        if (cameraSwitcher.cameras[key].selected) {
                            if (!userSelectedCamera) {
                                selectedCameraId = key;
                            }
                        }
                        if (cameraUiStates.hasOwnProperty(key)) {
                            cameraUiStates[key].selected = sutl.getNode(
                                cameraSwitcher,
                                ['cameras', key, 'selected'],
                                false
                            );
                            cameraUiStates[key].tracking = sutl.getNode(
                                cameraSwitcher,
                                ['cameras', key, 'tracking'],
                                false
                            );
                        } else {
                            log.warning(
                                'received room state for camera ' +
                                    key +
                                    ' that was not in room caps'
                            );
                        }
                    }
                }
            }
        }
        userSelectedCamera = false;

        for (key in cameraPresetUiStates) {
            if (
                cameraPresetUiStates.hasOwnProperty(key) &&
                sutl.getNode(room, ['states', 'cameraSwitchers', cameraSwitcherId]) !== null
            ) {
                cameraPresetUiStates[key].selected =
                    room.states.cameraSwitchers[cameraSwitcherId].cameraPreset === key;
            }
        }
    }

    function onRoomServiceOnlineChanged(online) {
        if (online) {
            room = RoomService.getRoom();
            room.$onChange(onRoomChanged);
        } else {
            if (room !== null) {
                room.$offChange(onRoomChanged);
                room = null;
                previousCameras = null;
                previousCameraPresets = null;
            }
        }
    }

    function onShowCameraMenu($event) {
        if (camerasMenu !== null) {
            $scope.camera = getSelectedCamera();
            camerasMenu.show($event).then(scrollToSelected);
        }
    }

    function onShowSelfViewMenu($event) {
        vm.uiSelfViewPosition = sutl.getNode(room, [
            'states',
            'cameraSwitchers',
            cameraSwitcherId,
            'selfViewPosition',
        ]);
        if (selfViewMenu !== null) selfViewMenu.show($event);
    }

    function onSelectCamera(camera) {
        if (!RoomService.online()) return;
        var promise = camerasMenu !== null ? camerasMenu.hide() : $q.resolve();
        promise.then(function () {
            selectedCameraId = camera.$key;
            userSelectedCamera = true;
            log.debug('user selected camera = ' + camera.name);
            room.$requestCameraSelected(selectedCameraId);
        });
    }

    function onSelectCameraPreset(preset) {
        if (!RoomService.online()) return;
        log.debug('selected camera preset: ' + preset.name);

        for (var key in cameraPresetUiStates) {
            // reset any other camera presets running states
            if (key !== preset.$key) {
                cameraPresetUiStates[key].running = false;
                if (angular.isDefined(cameraPresetUiStates[key].runningTimeout)) {
                    $timeout.cancel(cameraPresetUiStates[key].runningTimeout);
                    delete cameraPresetUiStates[key].runningTimeout;
                }
            }
        }

        cameraPresetUiStates[preset.$key].running = true;
        if (angular.isDefined(cameraPresetUiStates[preset.$key].runningTimeout)) {
            $timeout.cancel(cameraPresetUiStates[preset.$key].runningTimeout);
        }
        cameraPresetUiStates[preset.$key].runningTimeout = $timeout(function () {
            cameraPresetUiStates[preset.$key].running = false;
            delete cameraPresetUiStates[preset.$key].runningTimeout;
        }, cameraPresetRunningDuration);
        room.$requestCameraPreset(cameraSwitcherId, preset.$key);
    }

    function onSelectSelfViewPosition(position) {
        if (!RoomService.online()) return;
        vm.uiSelfViewPosition = position;
        log.debug('user selected self view position = ' + position);
        room.$requestSelfViewPosition(cameraSwitcherId, position);
        $timeout(250).then(function () {
            if (selfViewMenu !== null) selfViewMenu.hide();
        });
    }

    function onStateChange(event, toState, toParams, fromState, fromParams) {
        if (toState.name === 'control.camera' && room !== null) {
            room.$requestWakeCameras();
        } else if (toState.name !== 'control.camera') {
            if (camerasMenu !== null) {
                camerasMenu.hide();
            }
            if (selfViewMenu !== null) {
                selfViewMenu.hide();
            }
        }
    }

    function scrollToSelected() {
        if (camerasMenu === null || !angular.isDefined($scope.camera)) {
            return;
        }
        var item = camerasMenu.modalEl.querySelector('#' + $scope.camera.$key);
        if (!item) return;
        if (item.offsetTop < camerasMenu.modalEl.scrollTop) {
            $ionicScrollDelegate.$getByHandle('cameras-scroll').scrollTo(0, item.offsetTop, true);
        } else if (item.offsetTop + item.offsetHeight > camerasMenu.modalEl.clientHeight) {
            $ionicScrollDelegate
                .$getByHandle('cameras-scroll')
                .scrollTo(
                    0,
                    item.offsetTop + item.offsetHeight - camerasMenu.modalEl.clientHeight,
                    true
                );
        }
    }

    function selfView(enable) {
        if (
            !angular.isDefined(cameraSwitcherId) ||
            cameraSwitcherId === null ||
            !angular.isDefined(cameraSwitcherStates[cameraSwitcherId])
        ) {
            return;
        }
        if (arguments.length > 0) {
            cameraSwitcherStates[cameraSwitcherId].selfView = enable;
            room.$requestSelfView(cameraSwitcherId, enable);
        } else {
            return cameraSwitcherStates[cameraSwitcherId].selfView;
        }
    }

    function selfViewAuto(enable) {
        if (
            !angular.isDefined(cameraSwitcherId) ||
            cameraSwitcherId === null ||
            !angular.isDefined(cameraSwitcherStates[cameraSwitcherId])
        ) {
            return;
        }
        if (arguments.length > 0) {
            cameraSwitcherStates[cameraSwitcherId].selfViewAuto = enable;
            room.$requestSelfViewAuto(cameraSwitcherId, enable);
        } else {
            return cameraSwitcherStates[cameraSwitcherId].selfViewAuto;
        }
    }
}

module.exports = CameraController;
